<div *ngIf="cart?.current_state !== OrderState.Complete">
    <div class="flex flex-col" [class.pb-[80px]]="!isFnBApp">
        <ng-container *ngIf="!isFnBApp; else posOrderBtn">
            <a
                tuiButton
                type="button"
                appearance="primary"
                [disabled]="!cart.items.length || (totalNewItems$ | async) === 0 || false"
                size="m"
                class="flex-auto"
                routerLink="/checkout"
            >
                {{ 'progress_order' | transloco }}
            </a>
        </ng-container>

        <ng-template #posOrderBtn>
            <div class="flex items-end justify-between gap-4">
                <ng-container *tuiLet="businessModels$ | async as businessModels">
                    <ng-container *ngFor="let businessModel of businessModels">
                        <button
                            tuiButton
                            type="button"
                            appearance="primary"
                            (click)="submitOrder(businessModel)"
                            [disabled]="
                                !cart.items.length ||
                                (businessModel !== BusinessModel.PrePayment && (totalNewItems$ | async) === 0) ||
                                cart.paid_total >= cart.grand_total ||
                                false
                            "
                            size="m"
                            class="flex-auto"
                            [icon]="isPayLater(businessModel) ? 'svg::check' : 'svg::credit-card'"
                        >
                            {{ (isPayLater(businessModel) ? 'confirm' : 'pay') | transloco }}
                            <ng-container *ngIf="businessModels!.length === 1 && !isPayLater(businessModel)">
                                -
                                <span class="font-bold">{{ cart.grand_total || 0 | formatCurrency }}</span>
                            </ng-container>
                        </button>
                    </ng-container>
                </ng-container>
            </div>
        </ng-template>
    </div>
</div>
